const mapHandleToContentSearchSlug = (handle: string) => `content/brands/${handle}`;

export const getContentSearchSlugs = (searchCategoryHandles: string[]) =>
  searchCategoryHandles.map(mapHandleToContentSearchSlug).join(',');
